export default __webpack_public_path__ + "static/Custom-2fff5d70525626c3083950bf7c7f337f.jpg";